
import SharedImageTable from "../SharedImageTable";
import InitiativeTracker from "../InitiativeTracker"; // adjust path if needed
import DicePanel from "./panels/DicePanel";

export default function GuildhallPanels({
  diceVisible,
  imageVisible,
  initiativeVisible,
  socket,
  username,
  roomName,
  roomLeader,
}) {
  return (
    <>
      {/* 🎲 Dice Table */}
      {diceVisible && <DicePanel socket={socket} username={username} roomName={roomName} />}


      {/* 🖼️ Image Table */}
      {imageVisible && <SharedImageTable socket={socket} roomName={roomName} isRoomLeader={roomLeader} />}

      {/* 🧮 Initiative */}
      <div
        style={{
          display: initiativeVisible ? "block" : "none",
          width: "180px",
          background: "#222",
          borderRight: "2px solid #444",
          padding: "10px",
          overflowY: "auto",
        }}
      >
        <h2 style={{ textAlign: "center", color: "white", fontSize: "1.0rem", marginBottom: "1.5rem" }}>
          Initiative Tracker 🧮
        </h2>
        <InitiativeTracker />
      </div>
    </>
  );
}
